
import { useEffect, useState, createContext } from 'react';
import styled from "styled-components"

export const UserContext=createContext(null);

const Button=styled.button`
color:red;
text-align:center;
background-color:yellow;
&:hover{
    background-color:coral;
    & label{
        color:green
    }
};
&:active{
    background-color:lightblue;
};
`;

export const ButtonLabel=styled.label`
    font-size:25px;
    color:white
    `
// for every state update we are updating local storage value localStorage.setItem('dark-mode',dark)
    // useEffect(() => {
    //     localStorage.setItem('dark-mode', dark);
    //   }, [dark]);
    // const cat = localStorage.getItem('myCat');
    // localStorage.removeItem('myCat');
    // localStorage.clear();

function ES6(){
return(
    <div>
        <Button> <ButtonLabel>Get Items on the Center!!!</ButtonLabel></Button>
    </div>
)
}

export default ES6;